import { createSlice } from "@reduxjs/toolkit";

const selectedProductCategorySlice = createSlice({
  name: "selectedProductCategory",
  initialState: {
    selectedProductCategoryName: null,
  },
  reducers: {
    setSelectedProductCategory(state, action) {
      state.selectedProductCategoryName = action.payload;
    },
  },
});

export const { setSelectedProductCategory } =
  selectedProductCategorySlice.actions;
export default selectedProductCategorySlice.reducer;
